<script>
import { Bus } from '@/main'
import collect from 'collect.js'
import { Line } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

export default {
  extends: Line,
  props: ['height'],
  data: function () {
    return {
      statistics: ''
    }
  },
  created () {
    Bus.$on('oneMonthStatistics', (data) => {
      this.statistics = data.top_referrers

      const brandSuccess = getStyle('--success') || '#4dbd74'
      const brandInfo = getStyle('--info') || '#20a8d8'
      const brandDanger = getStyle('--danger') || '#f86c6b'

      this.renderChart({
        labels: this.days,
        datasets: [
          {
            label: this.referrers[0],
            backgroundColor: hexToRgba(brandInfo, 10),
            borderColor: brandInfo,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: this.firstRef
          },
          {
            label: this.referrers[1],
            backgroundColor: 'transparent',
            borderColor: brandSuccess,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: this.secondRef
          },
          {
            label: this.referrers[2],
            backgroundColor: 'transparent',
            borderColor: brandDanger,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            borderDash: [8, 5],
            data: this.thirdRef
          }
        ]
      }, {
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: Math.ceil(this.maxReq / 5),
              max: this.maxReq
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      })
    })
  },
  computed: {
    days () {
      const days = collect(this.statistics.top_three_referrer).first()
      return collect(days).except(['slug', 'requests']).keys().map((item) => {
        return this.$moment(item, 'DD-MM-YYYY').format('DD/MM')
      }).all()
    },
    referrers () {
      const referrers = collect(this.statistics.top_three_referrer).pluck('slug').map((item) => {
        return this.decodeKey(item)
      }).all()
      return referrers
    },
    firstRef () {
      return collect(this.statistics.top_three_referrer[0]).except(['slug', 'requests']).values().all()
    },
    secondRef () {
      return collect(this.statistics.top_three_referrer[1]).except(['slug', 'requests']).values().all()
    },
    thirdRef () {
      return collect(this.statistics.top_three_referrer[2]).except(['slug', 'requests']).values().all()
    },
    maxReq () {
      return Math.round((collect([collect(this.firstRef).max(), collect(this.secondRef).max(), collect(this.thirdRef).max()]).max()) * 1.15)
    }
  },
  methods: {
    decodeKey (key) {
      return key.replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u002e', '.').replace('\\u0024', '$').replace('\\\\', '\\')
    }
  },
  mounted () {

  },
  beforeDestroy () {
    Bus.$off('oneMonthStatistics')
  }
}
</script>
